import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { cpf } from 'cpf-cnpj-validator';
import { BaseComponent } from 'src/app/components/base-component';
import { SignatureService } from 'src/app/services/signature-service/signature.service';

@Component({
  selector: 'app-signer-mobile-form',
  templateUrl: './signer-mobile-form.component.html',
  styleUrls: ['./signer-mobile-form.component.scss']
})
export class SignerMobileFormComponent extends BaseComponent {
  
  @Input() signupInformations:any
  @Output() openForm = new EventEmitter<any>()

  blockBtn = false

  signerData = {
    name: '',
    email: '',
    cpf: '',
    born: '',
    signature: '',
    uidDoc: '',
    uidSigner: ''
  }

  validDocument?: boolean;
  
  public showOverlay = false;

  constructor(
    private signatureSevice: SignatureService,
    private router: Router
  ) {
    super();
  }

  blockScreen(): void {
    this.showOverlay = true;
  }

  close(): void {
    this.openForm.emit(false)
  }
  
  saveSignature() {
    this.blockBtn = true
    this.signerData.email = this.signupInformations.signer.email

    const postBody = {

      dto: {
        cpf: this.signerData.cpf,
        document: {
          file: {
            imageBlob: this.signerData.signature,
            typeImage: "image/png"
          },
          subscriber: {
            uid: this.signupInformations.uidSigner
          },
          uid: this.signupInformations.uidDoc,
        },
        fullname: this.signerData.name,
        bornDate: this.signerData.born
      }
    }
    
    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };
    
    const success = (pos) => {
      var crd = pos.coords;
      var longitude = crd.longitude + '';
      var  latitude = crd.latitude + '';

      console.log('Your current position is:');
      console.log(`Latitude : ${crd.longitude}`);
      console.log(`Longitude: ${crd.longitude}`);
      console.log(`More or less ${crd.accuracy} meters.`);

      this.signatureSevice.postSignature(this.signerData.cpf, this.signerData.signature,
        "image/png", this.signupInformations.uidSigner, this.signupInformations.uidDoc, this.signerData.name,
        this.signerData.born, longitude, latitude).subscribe(
          res => {
            sessionStorage.setItem('bodyToSign', JSON.stringify(postBody));
            sessionStorage.setItem('responseSigned', JSON.stringify(res));
            this.router.navigateByUrl('subscription-success');
          },
          errp => {
            this.blockBtn = false
          }
        )
    }
    
    const error = (err) => {
      console.warn(`ERROR(${err.code}): ${err.message}`);

      var longitude = '';
      var  latitude = '';

      this.signatureSevice.postSignature(this.signerData.cpf, this.signerData.signature,
        "image/png", this.signupInformations.uidSigner, this.signupInformations.uidDoc, this.signerData.name,
        this.signerData.born, longitude, latitude).subscribe(
          res => {
            sessionStorage.setItem('bodyToSign', JSON.stringify(postBody));
            sessionStorage.setItem('responseSigned', JSON.stringify(res));
            this.router.navigateByUrl('subscription-success');
          },
          errp => {
            this.blockBtn = false
          }
        )
    }
    
    navigator.geolocation.getCurrentPosition(success, error, options);
  }
  
  checkDocument() {
    if(this.signerData.cpf.trim().length === 0){
      this.validDocument = true
    } else {
      if(cpf.isValid(this.signerData.cpf)) {
        this.validDocument = true
      } else {
        this.validDocument = false
      }
    }
  }

  testeFunc(evt:any) {
    this.signerData.signature = evt
  }

  goToUseTerms() {
    window.open('https://gocontratos.com.br/termos-de-uso', '_blank');
  }

}
